import { render, staticRenderFns } from "./ExpertTermsReminderButton.vue?vue&type=template&id=42cebc9e&scoped=true"
import script from "./ExpertTermsReminderButton.vue?vue&type=script&lang=js"
export * from "./ExpertTermsReminderButton.vue?vue&type=script&lang=js"
import style0 from "./ExpertTermsReminderButton.vue?vue&type=style&index=0&id=42cebc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cebc9e",
  null
  
)

export default component.exports